import { trackerApi } from "../../core/api/TrackerApi";
import { ApiRouteParameter } from "../../core/api/WebApiTypes";
import { useQueryArray } from "../../core/components/helpers/queryHelper";
import { EntranceDto } from "./EntrancesDataType";

const fetchEntrances = async (locationId?: number) => {

    let param: ApiRouteParameter = {
        name: "locationId",
        value: locationId
    }
    let data: Array<EntranceDto> = await trackerApi.callServiceGet("/oot/entrances", [param]);

    return data;
}


export const useQueryEntrances = (locationId?: number) => {

    let query = useQueryArray<EntranceDto>(["/oot/entrances", locationId], () => fetchEntrances(locationId), "Get Entrances")

    return query;
}